import { memo, useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';

import { useSessionFeatureState } from '@hooks/storeHooks/useSessionState';
import { OutOfMinutesModal } from '../../../../components/Modals/OutOfMinutesModal';
import { useRemaining } from './useRemaining';

const Reminder: React.FC = memo(() => {
  const [showModal, setShowModal] = useState(false);
  const { secondsBalance, avatarReady } = useSessionFeatureState();

  const { containerId, isRunning } = useRemaining(secondsBalance, avatarReady);

  useEffect(() => {
    if (secondsBalance === 0 && isRunning) {
      setShowModal(true);
    }
  }, [secondsBalance, isRunning]);

  if (!avatarReady) {
    return null;
  }

  return (
    <>
      {showModal && (
        <OutOfMinutesModal onClose={() => setShowModal(false)} isSessionPage />
      )}
      <ToastContainer
        containerId={containerId}
        position="top-right"
        limit={1}
      />
    </>
  );
});

export { Reminder };
